import React, { ReactNode } from 'react'
import './overlay.css';

interface Props {
    children : ReactNode | ReactNode[];
    active   : boolean;
    onClick  : () => void;
    message  : string;
}


export class Overlay extends React.Component<Props> {

    render() {
        return (
            <div className="overlay-container">
                { this.props.children }
                { this.props.active && (
                <div className="overlay">
                  <button className="overlay-content" onClick={ () => this.props.onClick() }>{ this.props.message }</button>
                </div>
                )}
            </div>
        );
    }
}

